<template>
    <b-modal :id="idWebcam" no-close-on-esc no-close-on-backdrop>
        <web-cam
            ref="webcam"
            width="100%"
            :deviceId="deviceId"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
            @notsupported="onNotSupported"
            :isFrontCam="frontCam"
            :debug="true"
            :googleKey="googleKey"
        />
        <b-button class="captureFotoBtn" name="captureFotoBtn"
            @click="onCapture"
        >
            <div></div>
        </b-button>
        <template v-slot:modal-header>
            <h5 class="modal-title mb-0">Ambil Foto</h5>
            <b-button class="close" @click="closeAmbilFoto" name="closeAmbilFotoBtn">
                x
            </b-button>
        </template>
        <template v-slot:modal-footer>
            <b-button variant="secondary" name="cancelAmbilFotoBtn" @click="closeAmbilFoto">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { WebCam } from 'vue-cam-vision'
export default {
    name: 'modal-webcam',
    components: {
        WebCam,
    },
    data () {
        return {
            camera: null,
            deviceId: null,
            devices: [],
            frontCam: true,
            report: null,
            googleKey: process.env.VUE_APP_OCR_GVA,
            resultFoto: null
        }
    },
    props: {
        idWebcam:{ type: String, default: 'modal-ambil-foto'}
    },
    methods: {
        async onCapture () {
            navigator.geolocation.getCurrentPosition(
                () => {

                },
                () => {

                },
            )

            this.resultFoto = await this.$refs.webcam.capture()

            this.$refs.webcam.stop()
            this.$bvModal.hide(this.idWebcam || 'modal-ambil-foto')
            this.$emit("photoTaken", this.resultFoto)
        },
        onStarted (stream) {
            console.log('On Started Event', stream)
        },
        onStopped (stream) {
            console.log('On Stopped Event', stream)
        },
        onError (error) {
            console.log('On Error Event', error)
            this.$helper.toastErr(this, "Tidak dapat menggunakan kamera karena akses ditolak dari browser. Hubungi HO / IT untuk keterangan lebih lanjut")
        },
        onCameras (cameras) {
            this.devices = cameras
            console.log('On Cameras Event', cameras)
        },
        onCameraChange (deviceId) {
            this.deviceId = deviceId
            this.camera = deviceId
            console.log('On Camera Change Event', deviceId)
            
        },
        onNotSupported () {
            this.$bvModal.hide(this.idWebcam || 'modal-ambil-foto');
        },
        closeAmbilFoto(stream){
            console.log('On Stopped Event', stream)
            this.$refs.webcam.stop()
            this.$bvModal.hide(this.idWebcam || 'modal-ambil-foto')
        },
    }
}
</script>